export const unfoldVCardLines = (text = "") => {
  return String(text)
    .replace(/\r/g, "")
    .replace(/\n[ \t]/g, "");
};
export function parseSingleVCard(block: string) {
  const lines = unfoldVCardLines(block).split("\n");

  let name = "";
  let number = "";
  let numberDisplay = "";
  let email = "";
  let org = "";
  let title = "";

  for (const rawLine of lines) {
    const line = String(rawLine || "").trim();
    if (!line || !line.includes(":")) continue;

    const separatorIndex = line.indexOf(":");
    const key = line.substring(0, separatorIndex).trim().toUpperCase();
    const value = line.substring(separatorIndex + 1).trim();

    if (key === "FN" || key.endsWith(".FN")) {
      name = value;
      continue;
    }

    if (key === "ORG" || key.endsWith(".ORG")) {
      org = value;
      continue;
    }

    if (key === "TITLE" || key.endsWith(".TITLE")) {
      title = value;
      continue;
    }

    if (
      key === "EMAIL" ||
      key.startsWith("EMAIL;") ||
      key.endsWith(".EMAIL") ||
      key.includes(".EMAIL;")
    ) {
      email = value;
      continue;
    }

    if (
      key === "TEL" ||
      key.startsWith("TEL;") ||
      key.endsWith(".TEL") ||
      key.includes(".TEL;")
    ) {
      const waidMatch = key.match(/WAID=(\d+)/i);

      if (!number && waidMatch?.[1]) {
        number = waidMatch[1].replace(/\D/g, "");
      }

      if (!numberDisplay && value) {
        numberDisplay = value;
      }

      if (!number && value) {
        number = value.replace(/\D/g, "");
      }

      continue;
    }
  }

  if (!name) {
    name = org || numberDisplay || number || "Contacto compartido";
  }

  return {
    name,
    number: number || "",
    numberDisplay: numberDisplay || "",
    email: email || "",
    org: org || "",
    title: title || "",
    numbers: numberDisplay ? [numberDisplay] : number ? [number] : []
  };
}
export const parseMultiVCard = (body = "") => {
  const text = unfoldVCardLines(body);
  const matches = text.match(/BEGIN:VCARD[\s\S]*?END:VCARD/g) || [];
  return matches.map(parseSingleVCard);
};
